module.exports = __webpack_public_path__ + "img/Sad.07d10d9e.svg";